export default "__VITE_ASSET__050760a6__"